export const SHIPPING_MANAGEMENT = {
    CREATE_SHIPPING_ACCOUNT: "create-shipping-account",
    DELETE_CARRIER: "delete-carrier",
    ACTION_MENU_BTN: "action-menu",
    DIALOG_DELETE: "dialog-delete",
    DIALOG_CANCEL: "dialog-cancel",
    CARRIER_SETTINGS: "carrier-settings",
    SELECT_CARRIER: "select-carrier",
    SAVE_CARRIER: "save-carrier",
    SAVE_PREFERENCES: "save-preferences",
    SELECT_SERVICES: "select-services",
    SAVE_SERVICES: "save-services",
};
